import { Link } from "react-router-dom"
import styled from "styled-components"
import { DashboardCards } from "../styled/CustomCard"
import { AdminPaths } from "../../constants/paths"

const PendingClaims = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  padding: 1rem;
  font-size: 3rem;
  font-weight: 800;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.primaryColor};
  color: #fff;

  span {
    font-size: 1.25rem;
    font-weight: 500;
    display: block;
  }
`

const Claims = styled.div`
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  padding: 0.75rem;
  background-color: #fafafa;

  span:nth-child(2) {
    display: block;
    font-weight: normal;
    font-size: 0.9rem;
  }
`

const Divider = styled.div`
  padding: 1px;
  background-color: #eee;
  width: 60%;
  margin: auto;
`

type ClaimsData = {
  approvedClaimsCount: number
  declinedClaimsCount: number
  pendingClaimsCount: number
  totalClaimsCount: number
}

type Props = {
  claims: ClaimsData
}

const ClaimsCard = ({ claims }: Props) => {
  return (
    <div className="container-fluid h-100">
      <DashboardCards>
        <div className="row">
          <div className="col-xl-7 col-lg-12 col-md-6">
            <PendingClaims>
              <div className="row">
                <div className="col-12">{claims.pendingClaimsCount}</div>
                <div className="col-12">
                  <span>Pending Claims</span>
                </div>
              </div>
            </PendingClaims>
          </div>
          <div className="col-xl-5 col-lg-12 col-md-6">
            <Claims>
              <span>{claims.totalClaimsCount}</span>
              <span>Total Claims</span>
            </Claims>
            <Divider />
            <Claims>
              <span>{claims.approvedClaimsCount}</span>
              <span>Approved Claims</span>
            </Claims>
            <Divider />
            <Claims>
              <span>{claims.declinedClaimsCount}</span>
              <span>Declined Claims</span>
            </Claims>
          </div>
        </div>
        <div className="row">
          <div className="col-12 pt-2 text-center">
            <Link to={AdminPaths.CLAIM_APPROVAL_PATH}>
              Review Pending Claims
            </Link>
          </div>
        </div>
      </DashboardCards>
    </div>
  )
}

export default ClaimsCard
